import {Component, ConfigOptions} from 'panel';

import {serializeAttributes} from 'common/util';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import 'common/components/select';

import {SupportWidgetFormState} from './support-widget-form';
import template from './index.jade';

interface SupportWidgetState {
  isMaximized: boolean;
}

export class SupportWidget extends Component<SupportWidgetState> {
  private formState: SupportWidgetFormState;

  static get attrsSchema() {
    return {
      'billing-account': {type: `json`, description: `interface: BillingAccount`},
      'service-plan-ids': {type: `json`, description: `list of service plans for all orgs associated with this user`},
      'events-plan-id': `number`,
      'feature-gate-name': `string`,
      'people-plan-id': `number`,
      'project-id': `number`,
      'total-arr': `number`,
      'user-age-in-days': `number`,
      'user-email': `string`,
      'user-id': `number`,
      'user-name': `string`,
      'should-override-free-warning': `boolean`,
    };
  }

  get config(): ConfigOptions<SupportWidgetState> {
    return {
      template,
      useShadowDom: true,
      defaultState: {
        isMaximized: false,
      },
      helpers: {
        handleSupportWidgetClosed: () => {
          this.dispatchEvent(new CustomEvent(`close`));
        },

        handleSupportWidgetMaximized: () => {
          this.dispatchEvent(new CustomEvent(`maximize`, {detail: {isMaximized: true}}));
          this.update({isMaximized: true});
        },

        handleSupportWidgetUnmaximized: () => {
          this.dispatchEvent(new CustomEvent(`maximize`, {detail: {isMaximized: false}}));
          this.update({isMaximized: false});
        },

        handleFormStateChange: (ev) => {
          this.formState = ev.detail;
        },

        getFormAttributes: () => {
          const newFormState: SupportWidgetFormState = Object.assign({}, this.formState, {
            isMaximized: this.state.isMaximized,
            isUploadingFiles: false,
          });
          return serializeAttributes({
            'data-state': newFormState,
            ...this.attrs(),
          });
        },
      },
    };
  }

  // Opens the support widget in a maximized state
  set maximize(isMaximized: boolean) {
    this.update({isMaximized});
  }
}

export const SupportWidgetEl = defineAndMakeJsxFactory(`mp-support-widget`, SupportWidget);
export const SupportWidgetReact = panel2react(`mp-support-widget`, SupportWidget);
